module.exports = __webpack_public_path__ + "static/media/barcode.en.04933b5d.png";